import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false,
    key: null,
    requestId: null
};
var getAddressLaoProvinceSlice = createSlice({
    name: "getAddressLaoProvince",
    initialState: initialState,
    reducers: {
        fetchData: function(state, param) {
            var payload = param.payload;
            state.data = null;
            state.isFetching = true;
            state.isError = false;
            state.key = payload.key;
            state.requestId = payload.requestId;
        },
        fetchDataSuccess: function(state, param) {
            var payload = param.payload;
            if (state.requestId !== payload.requestId) return;
            state.data = payload.data;
            state.isFetching = false;
        },
        fetchDataFailure: function(state, param) {
            var payload = param.payload;
            if (state.requestId !== payload.requestId) return;
            state.isFetching = false;
            state.isError = true;
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _getAddressLaoProvinceSlice_actions = getAddressLaoProvinceSlice.actions;
export var fetchData = _getAddressLaoProvinceSlice_actions.fetchData, fetchDataSuccess = _getAddressLaoProvinceSlice_actions.fetchDataSuccess, fetchDataFailure = _getAddressLaoProvinceSlice_actions.fetchDataFailure, resetState = _getAddressLaoProvinceSlice_actions.resetState;
export default getAddressLaoProvinceSlice.reducer;
